import React, { useEffect, useState } from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CropOriginalIcon from "@mui/icons-material/CropOriginal";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import ExpandLess from "@mui/icons-material/ExpandLess";
import Logger from "../../services/Logger";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import GridOnIcon from "@mui/icons-material/GridOn";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import MessageIcon from "@mui/icons-material/Message";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Stack from "@mui/material/Stack";
import { AiOutlineStop, AiOutlineTags } from "react-icons/ai";
import { FaFacebook, FaInstagram, FaRegFileWord } from "react-icons/fa";
import { FaUsersGear } from "react-icons/fa6";
import { GrContact, GrSystem, GrTable } from "react-icons/gr";
import { IoCloudDownloadOutline, IoExtensionPuzzleOutline, IoSettingsOutline } from "react-icons/io5";
import { MdOutlineAdUnits, MdOutlineArticle, MdOutlineAudioFile, MdOutlineBarChart, MdOutlineCampaign, MdOutlineCategory, MdOutlineEventRepeat, MdOutlineHistory, MdOutlineImage, MdOutlineLink, MdOutlineNotifications, MdOutlineSchedule, MdOutlineSchool, MdOutlineScience, MdOutlineShare, MdOutlineTopic } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import UserService from "../../services/UserService";
import Item from "../components/Item";
import { ADMIN_SLIDING_BROWSE_PATH, ADMIN_SLIDING_PACKS_PATH, ADMIN_SLIDING_PLAY_PATH, ADMIN_SLIDING_STATS_PATH } from "../story/adminSlidingRoutes";
import {
    ADMIN_ADVERTISEMENT_PATH,
    ADMIN_ADVERTISEMENT_APP_SCREENSHOT_LINKS_PATH,
    ADMIN_ADVERTISEMENT_IPHONE_BACKGROUND_PATH,
    ADMIN_AD_SOCIAL_FACEBOOK_PATH,
    ADMIN_AD_SOCIAL_INSTAGRAM_PATH,
    ADMIN_AD_SOCIAL_PATH,
    ADMIN_AD_SOCIAL_WORD_WHEEL_GRID_PATH,
    ADMIN_AD_SOCIAL_WORD_WHEEL_PATH,
    ADMIN_ADVERTISEMENT_TUTORS_PATH,
    ADMIN_ADVERTISEMENT_PRODUCT_ICON_PATH,
    ADMIN_ADVERTISEMENT_PROMOTION_PATH,
} from "../advertisement/advertisementRoutes";
import { ADMIN_CRM_PATH } from "../crm/crmRoutes";

/** Matches react-icons usage in createNestedMenuItem (onClick, size). */
function AutoAwesomeMenuIcon({ onClick, size = "1.5rem", ...rest }) {
    return <AutoAwesomeIcon onClick={onClick} sx={{ fontSize: size }} {...rest} />;
}

function ViewWeekMenuIcon({ onClick, size = "1.5em", ...rest }) {
    return <ViewWeekIcon onClick={onClick} sx={{ fontSize: size }} {...rest} />;
}

function CropOriginalMenuIcon({ onClick, size = "1.5em", ...rest }) {
    return <CropOriginalIcon onClick={onClick} sx={{ fontSize: size }} {...rest} />;
}

export default function AdminSideBar({ drawerOpen, setDrawerOpen }) {
    const navigate = useNavigate();
    const location = useLocation();

    const [openPuzzle, setOpenPuzzle] = useState(false);
    const [openCross, setOpenCross] = useState(false);
    const [openWordWheel, setOpenWordWheel] = useState(false);
    const [openSetting, setOpenSetting] = useState(false);
    const [openSystem, setOpenSystem] = useState(false);
    const [openJigsaw, setOpenJigsaw] = useState(false);
    const [openSliding, setOpenSliding] = useState(false);
    const [openAccount, setOpenAccount] = useState(false);
    const [openAdvertisement, setOpenAdvertisement] = useState(false);
    const [openTutor, setOpenTutor] = useState(false);
    const [openSocial, setOpenSocial] = useState(false);

    const handleNavigate = (path) => {
        navigate(path);
    };

    // Helper function to create nested menu items
    const createNestedMenuItem = (IconComponent, text, path) => (
        <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon sx={{ minWidth: "40px" }}>
                <IconComponent
                    onClick={() => {
                        setDrawerOpen(!drawerOpen);
                    }}
                    size="1.5em"
                />
            </ListItemIcon>
            <ListItemText primary={text} onClick={() => handleNavigate(path)} />
        </ListItemButton>
    );

    const createDeepNestedMenuItem = (IconComponent, text, path) => (
        <ListItemButton sx={{ pl: 6 }}>
            <ListItemIcon sx={{ minWidth: "40px" }}>
                <IconComponent
                    onClick={() => {
                        setDrawerOpen(!drawerOpen);
                    }}
                    size="1.5em"
                />
            </ListItemIcon>
            <ListItemText primary={text} onClick={() => handleNavigate(path)} />
        </ListItemButton>
    );

    useEffect(() => {
        // Logger.log("useEffect in SideBar");
        UserService.getUserInfo().then(() => {
            // Logger.log("///");
            // Logger.log(u.cloudUser);
            // setUserInfo(u.cloudUser);
        });

        // Logger.log(drawerOpen);
    }, [drawerOpen]);

    useEffect(() => {
        if (location.pathname.startsWith("/admin/advertisement")) {
            setOpenAdvertisement(true);
        }
        if (location.pathname === "/admin/tutor" || location.pathname.startsWith("/admin/tutor/")) {
            setOpenTutor(true);
        }
        if (location.pathname.startsWith("/admin/advertisement/social")) {
            setOpenSocial(true);
        }
        if (location.pathname.startsWith("/admin/jigsaw")) {
            setOpenJigsaw(true);
        }
        if (location.pathname.startsWith("/admin/sliding")) {
            setOpenSliding(true);
        }
        if (location.pathname.startsWith("/admin/system")) {
            setOpenSystem(true);
        }
        if (
            location.pathname.startsWith("/admin/account")
            || location.pathname.startsWith("/admin/crm")
            || location.pathname.startsWith("/admin/mailing_list")
            || location.pathname.startsWith("/admin/contacts")
            || location.pathname.startsWith("/admin/referral")
            || location.pathname.startsWith("/admin/feedback")
            || location.pathname.startsWith("/admin/notification")
        ) {
            setOpenAccount(true);
        }
    }, [location.pathname]);

    return (
        <>
            <Stack spacing={2}>
                <Item>
                    <List
                        sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Menu
                            </ListSubheader>
                        }
                    >
                        {/* Account */}
                        <ListItemButton onClick={() => setOpenAccount(!openAccount)}>
                            <ListItemIcon>
                                <FaUsersGear
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                    size="1.5em"
                                />
                            </ListItemIcon>
                            <ListItemText primary="Account" onClick={() => handleNavigate("/admin/account")} />
                            {openAccount ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openAccount} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(FaUsersGear, "Users", "/admin/account")}
                                {createNestedMenuItem(
                                    AccountBalanceWalletOutlinedIcon,
                                    "Credit",
                                    "/admin/account/credit"
                                )}
                                {createNestedMenuItem(
                                    EmojiEventsOutlinedIcon,
                                    "Coins",
                                    "/admin/account/coins"
                                )}
                                {createNestedMenuItem(
                                    LeaderboardOutlinedIcon,
                                    "Leader Boards",
                                    "/admin/account/leader-board"
                                )}
                                {createNestedMenuItem(
                                    TimerOutlinedIcon,
                                    "Speed ranks",
                                    "/admin/account/speed-rank"
                                )}
                                {createNestedMenuItem(GrContact, "CRM", ADMIN_CRM_PATH)}
                                {createNestedMenuItem(MdOutlineNotifications, "Notification", "/admin/notification")}
                            </List>
                        </Collapse>

                        {/* Puzzle - Crossword */}
                        <ListItemButton onClick={() => setOpenCross(!openCross)}>
                            <ListItemIcon>
                                <GridOnIcon
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText primary="Crossword" onClick={() => handleNavigate("/admin/puzzle")} />
                            {openCross ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openCross} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemIcon sx={{ minWidth: "40px" }}>
                                        <GridOnIcon
                                            onClick={() => {
                                                setDrawerOpen(!drawerOpen);
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Board" onClick={() => handleNavigate("/admin/puzzle/cross_board")} />
                                </ListItemButton>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemIcon sx={{ minWidth: "40px" }}>
                                        <GridOnIcon
                                            onClick={() => {
                                                setDrawerOpen(!drawerOpen);
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Template" onClick={() => handleNavigate("/admin/puzzle/cross_tpl")} />
                                </ListItemButton>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemIcon sx={{ minWidth: "40px" }}>
                                        <GridOnIcon
                                            onClick={() => {
                                                setDrawerOpen(!drawerOpen);
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Play" onClick={() => handleNavigate("/admin/puzzle/cross_play")} />
                                </ListItemButton>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemIcon sx={{ minWidth: "40px" }}>
                                        <GridOnIcon
                                            onClick={() => {
                                                setDrawerOpen(!drawerOpen);
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Stats" onClick={() => handleNavigate("/admin/puzzle/cross_stats")} />
                                </ListItemButton>
                            </List>
                        </Collapse>

                        {/* Puzzle - Grid */}
                        <ListItemButton onClick={() => setOpenPuzzle(!openPuzzle)}>
                            <ListItemIcon>
                                <MessageIcon
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText primary="Grid" onClick={() => handleNavigate("/admin/puzzle")} />
                            {openPuzzle ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openPuzzle} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(MessageIcon, "Board", "/admin/puzzle/grid_board")}
                            </List>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(MessageIcon, "Template", "/admin/puzzle/grid_tpl")}
                            </List>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(MessageIcon, "Pack (mini)", "/admin/puzzle/grid_pack")}
                            </List>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(MessageIcon, "Play", "/admin/puzzle/grid_play")}
                            </List>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(MessageIcon, "Stats", "/admin/puzzle/grid_stats")}
                            </List>
                        </Collapse>

                        {/* Puzzle - Word Wheel */}
                        <ListItemButton onClick={() => setOpenWordWheel(!openWordWheel)}>
                            <ListItemIcon>
                                <GridOnIcon
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText primary="Word Wheel" onClick={() => handleNavigate("/admin/puzzle")} />
                            {openWordWheel ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openWordWheel} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(GridOnIcon, "Board", "/admin/puzzle/word_wheel_board")}
                            </List>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(GridOnIcon, "Template", "/admin/puzzle/word_wheel_tpl")}
                            </List>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(GridOnIcon, "Pack", "/admin/puzzle/word_wheel_pack")}
                            </List>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(GridOnIcon, "Play", "/admin/puzzle/word_wheel_play")}
                            </List>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(GridOnIcon, "Stats", "/admin/puzzle/word_wheel_stats")}
                            </List>
                        </Collapse>

                        {/* Story (root) */}
                        <ListItemButton>
                            <ListItemIcon>
                                <AutoStoriesOutlinedIcon
                                    sx={{ fontSize: "1.5rem" }}
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText primary="Story" onClick={() => handleNavigate("/admin/story")} />
                        </ListItemButton>

                        {/* Jigsaw */}
                        <ListItemButton onClick={() => setOpenJigsaw(!openJigsaw)}>
                            <ListItemIcon>
                                <IoExtensionPuzzleOutline
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                    size="1.5em"
                                />
                            </ListItemIcon>
                            <ListItemText primary="Jigsaw" />
                            {openJigsaw ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openJigsaw} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(IoExtensionPuzzleOutline, "Board", "/admin/jigsaw/browse")}
                                {createNestedMenuItem(GrTable, "Template", "/admin/jigsaw/template")}
                                {createNestedMenuItem(MdOutlineCategory, "Packs", "/admin/jigsaw/packs")}
                                {createNestedMenuItem(IoExtensionPuzzleOutline, "Play", "/admin/jigsaw/play")}
                                {createNestedMenuItem(IoExtensionPuzzleOutline, "Stats", "/admin/jigsaw/stats")}
                            </List>
                        </Collapse>

                        {/* Sliding */}
                        <ListItemButton onClick={() => setOpenSliding(!openSliding)}>
                            <ListItemIcon>
                                <ViewWeekIcon
                                    sx={{ fontSize: "1.5rem" }}
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText primary="Sliding" onClick={() => handleNavigate(ADMIN_SLIDING_BROWSE_PATH)} />
                            {openSliding ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openSliding} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(ViewWeekMenuIcon, "Board", ADMIN_SLIDING_BROWSE_PATH)}
                                {createNestedMenuItem(ViewWeekMenuIcon, "Play", ADMIN_SLIDING_PLAY_PATH)}
                                {createNestedMenuItem(ViewWeekMenuIcon, "Stats", ADMIN_SLIDING_STATS_PATH)}
                                {createNestedMenuItem(MdOutlineCategory, "Packs", ADMIN_SLIDING_PACKS_PATH)}
                            </List>
                        </Collapse>

                        {/* Advertisement */}
                        <ListItemButton onClick={() => setOpenAdvertisement(!openAdvertisement)}>
                            <ListItemIcon>
                                <MdOutlineAdUnits
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                    size="1.5em"
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary="AD"
                                onClick={() => handleNavigate(ADMIN_ADVERTISEMENT_PATH)}
                            />
                            {openAdvertisement ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openAdvertisement} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(MdOutlineAdUnits, "Resources", ADMIN_ADVERTISEMENT_PATH)}
                                {createNestedMenuItem(
                                    CropOriginalMenuIcon,
                                    "App Background",
                                    ADMIN_ADVERTISEMENT_IPHONE_BACKGROUND_PATH,
                                )}
                                {createNestedMenuItem(
                                    MdOutlineScience,
                                    "Prototype",
                                    "/admin/system/prototype",
                                )}
                                {createNestedMenuItem(
                                    MdOutlineLink,
                                    "App & Screenshot Links",
                                    ADMIN_ADVERTISEMENT_APP_SCREENSHOT_LINKS_PATH,
                                )}
                                {createNestedMenuItem(
                                    MdOutlineSchool,
                                    "Tutor",
                                    ADMIN_ADVERTISEMENT_TUTORS_PATH,
                                )}
                                {createNestedMenuItem(
                                    MdOutlineImage,
                                    "Product Icon",
                                    ADMIN_ADVERTISEMENT_PRODUCT_ICON_PATH,
                                )}
                                {createNestedMenuItem(
                                    MdOutlineCampaign,
                                    "Promotion",
                                    ADMIN_ADVERTISEMENT_PROMOTION_PATH,
                                )}
                                <ListItemButton
                                    sx={{ pl: 4 }}
                                    onClick={() => setOpenSocial(!openSocial)}
                                >
                                    <ListItemIcon sx={{ minWidth: "40px" }}>
                                        <MdOutlineShare
                                            onClick={() => {
                                                setDrawerOpen(!drawerOpen);
                                            }}
                                            size="1.5em"
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Social"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleNavigate(ADMIN_AD_SOCIAL_PATH);
                                        }}
                                    />
                                    {openSocial ? <ExpandLess /> : <ExpandMore />}
                                </ListItemButton>
                                <Collapse in={openSocial} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {createDeepNestedMenuItem(
                                            FaFacebook,
                                            "Facebook",
                                            ADMIN_AD_SOCIAL_FACEBOOK_PATH,
                                        )}
                                        {createDeepNestedMenuItem(
                                            FaInstagram,
                                            "Instagram",
                                            ADMIN_AD_SOCIAL_INSTAGRAM_PATH,
                                        )}
                                        {createDeepNestedMenuItem(
                                            ViewWeekMenuIcon,
                                            "Word Wheel",
                                            ADMIN_AD_SOCIAL_WORD_WHEEL_PATH,
                                        )}
                                        {createDeepNestedMenuItem(
                                            GridOnIcon,
                                            "Word Wheel (Grid)",
                                            ADMIN_AD_SOCIAL_WORD_WHEEL_GRID_PATH,
                                        )}
                                    </List>
                                </Collapse>
                            </List>
                        </Collapse>

                        {/* Tutor stories */}
                        <ListItemButton onClick={() => setOpenTutor(!openTutor)}>
                            <ListItemIcon>
                                <MdOutlineSchool
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                    size="1.5em"
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary="Tutor"
                                onClick={() => handleNavigate("/admin/tutor")}
                            />
                            {openTutor ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openTutor} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(MdOutlineArticle, "Board", "/admin/tutor")}
                                {createNestedMenuItem(MdOutlineHistory, "History", "/admin/tutor?tab=history")}
                            </List>
                        </Collapse>

                        {/* Content Setting */}
                        <ListItemButton onClick={() => setOpenSetting(!openSetting)}>
                            <ListItemIcon>
                                <IoSettingsOutline
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                    size="1.5em"
                                />
                            </ListItemIcon>
                            <ListItemText primary="Setting" onClick={() => handleNavigate("/admin/setting")} />
                            {openSetting ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                        <Collapse in={openSetting} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {/* Topic */}
                                {createNestedMenuItem(MdOutlineTopic, "Topic", "/admin/topic")}

                                {/* Genre */}
                                {createNestedMenuItem(MdOutlineCategory, "Genre", "/admin/genre")}

                                {/* Banned Words */}
                                {createNestedMenuItem(AiOutlineStop, "Banned Words", "/admin/banned")}

                                {/* Bedrock Idea */}
                                {createNestedMenuItem(AutoAwesomeMenuIcon, "Bedrock Idea", "/admin/bedrock-idea")}

                                {/* Publisher */}
                                {createNestedMenuItem(MdOutlineSchedule, "Publisher", "/admin/publisher")}

                                {/* Task Scheduler */}
                                {createNestedMenuItem(MdOutlineEventRepeat, "Task Scheduler", "/admin/task-scheduler")}

                                {/* Audio (BGM library) */}
                                {createNestedMenuItem(MdOutlineAudioFile, "Audio", "/admin/audio")}

                                {/* Logs */}
                                {createNestedMenuItem(MdOutlineArticle, "Logs", "/admin/logs")}

                                {/* Statistics */}
                                {createNestedMenuItem(MdOutlineBarChart, "Statistics", "/admin/statistics")}
                            </List>
                        </Collapse>

                        {/* System */}
                        <ListItemButton onClick={() => setOpenSystem(!openSystem)}>
                            <ListItemIcon>
                                <GrSystem
                                    onClick={() => {
                                        setDrawerOpen(!drawerOpen);
                                    }}
                                    size="1.5em"
                                />
                            </ListItemIcon>
                            <ListItemText primary="System" onClick={() => handleNavigate("/admin/system")} />
                            {openSystem ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openSystem} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {createNestedMenuItem(GrTable, "Anything", "/admin/system/anything")}
                                {createNestedMenuItem(AiOutlineTags, "Tag migration", "/admin/system/tag-migration")}
                                {createNestedMenuItem(FaRegFileWord, "API Integrations", "/admin/system/integrate")}
                                {createNestedMenuItem(IoCloudDownloadOutline, "Ingest", "/admin/system/ingest")}
                            </List>
                        </Collapse>
                    </List>
                </Item>
            </Stack>
        </>
    );
}
